define([], function()
{
    return {
        arrow: [{
            type: 'triangle',
            circle: false,
            offset: {
                y: -4
            },
            angleOffset: 0,
            position: 1.0
        }],
        cross: [{
            type: 'cross',
            circle: true,
            offset: {
                y: 0
            },
            angleOffset: 0,
            position: 1.0
        }],
        diamond: [{
            type: 'diamond',
            circle: false,
            offset: {
                y: 0
            },
            size: 2.0,
            angleOffset: 0,
            position: 0.0
        }]
    };
});



// WEBPACK FOOTER //
// ./system/domain/entity/relation-marks-pattern.js